import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import classNames from 'classnames';
import Icon from '@icon/Icon';
import { Dropdown } from '@widget/popups/Dropdown';
import SearchBox from '@widget/forms/inputs/SearchBox';
/**
 * @export
 * A small chip-like button that opens a scrollable list, for long lists that would clutter the page inline.
 *
 * @example
 * ```
 * <ListDropdown label="3 pages" items={['home-view', 'alarm-view', 'point-view']} />
 * ```
 *
 * @category Data Display
 */
const ListDropdown = ({ label, items, variant = 'secondary', searchThreshold = 10, className, }) => {
    const [query, setQuery] = useState('');
    const shown = useMemo(() => {
        const q = query.trim().toLowerCase();
        const text = (item) => typeof item === 'string' ? item : `${item.label} ${item.detail || ''}`;
        return q ? items.filter((item) => text(item).toLowerCase().includes(q)) : items;
    }, [items, query]);
    return (_jsx(Dropdown, { className: classNames('uxpcore_listdropdown', className), contentClassName: "uxpcore_listdropdown__content", position: "bottom-left", minWidth: "16rem", maxWidth: "28rem", trigger: _jsxs("button", { type: "button", className: classNames('uxpcore_listdropdown__trigger', `uxpcore_listdropdown__trigger--${variant}`), children: [label, _jsx(Icon, { icon: "fas chevron-down" })] }), content: _jsxs("div", { className: "uxpcore_listdropdown__panel", children: [items.length > searchThreshold && (_jsx("div", { className: "uxpcore_listdropdown__search", children: _jsx(SearchBox, { value: query, onChange: setQuery }) })), _jsx("ul", { className: "uxpcore_listdropdown__list", children: shown.map((item, i) => typeof item === 'string' ? (_jsx("li", { className: "uxpcore_listdropdown__item", children: item }, `${item}-${i}`)) : (_jsxs("li", { className: "uxpcore_listdropdown__item", children: [_jsx("div", { className: "uxpcore_listdropdown__item-label", children: item.label }), item.detail && _jsx("div", { className: "uxpcore_listdropdown__item-detail", children: item.detail })] }, `${item.label}-${i}`))) })] }) }));
};
export default ListDropdown;
